export const uiHelpers = {
  data() {
    return {
      collapsedElements: [], // List of elements marked as not showing (collapsed)
    };
  },
  methods: {
    /**
     * Show/hide elements and store their state in the session.
     *
     * @param {element or string} event - The source that triggered this
     * @param {boolean} fromCollapser - Whether the collapser element triggered this (flips target and source)
     */
    toggleCollapse(event, fromCollapser = false) {
      const toggleCollapse = 'toggleCollapse'; // TODO: Use config value
      const targetName = (fromCollapser ? event.id : event.currentTarget.dataset.target.substring(1)); // Name of target w/o the '#'
      const sourceName = (fromCollapser ? event.dataset.target.substring(1) : event.currentTarget.id); // ID of element that triggered this
      const i = this.collapsedElements.indexOf(targetName); // Index of current target, if it exists in the list

      if (i === -1 && document.getElementById(targetName).classList.contains('d-flex')) {
        document.getElementById(targetName).classList.remove('d-flex'); // Toggle whether it shows
        document.getElementById(sourceName).classList.remove('active'); // Toggle +/-
        this.collapsedElements.push(targetName); // Add to list of showing elements
      } else {
        document.getElementById(targetName).classList.add('d-flex'); // Toggle whether it shows
        document.getElementById(sourceName).classList.add('active'); // Toggle +/-
        this.collapsedElements.splice(i, 1); // Remove from list of showing elements
      }

      sessionStorage.setItem(toggleCollapse, JSON.stringify(this.collapsedElements)); // Set new list back into session
    },
  },
};

export const none = {
  // TODO: Remove this hack that suppresses the eslint error: Prefer default export "export const uiHelpers = {""
};



// WEBPACK FOOTER //
// ./src/mixins/uiHelpers.js